import Echo from "laravel-echo";
import Pusher from "pusher-js";
import http from "@/services/http";

window.Pusher = Pusher;

let echoInstance = null;

export function getEcho() {
  return echoInstance;
}

export function initEcho() {
  if (echoInstance) return echoInstance;

  echoInstance = new Echo({
    broadcaster: "pusher",
    key: process.env.VUE_APP_PUSHER_KEY,
    wsHost: process.env.VUE_APP_PUSHER_HOST || window.location.hostname,
    wsPort: Number(process.env.VUE_APP_PUSHER_PORT || 6001),
    wssPort: Number(process.env.VUE_APP_PUSHER_PORT || 6001),
    // Path-based routing no ingress (ex: "/soketi"). Vazio em dev local (Soketi escuta na raiz).
    wsPath: process.env.VUE_APP_PUSHER_PATH || "",
    forceTLS: (process.env.VUE_APP_PUSHER_SCHEME || "http") === "https",
    enabledTransports: ["ws", "wss"],
    cluster: process.env.VUE_APP_PUSHER_CLUSTER || "mt1",
    disableStats: true,

    // Authorizer customizado: usa nosso axios (já injeta Bearer Sanctum via interceptor).
    // Roda a cada inscrição em canal privado/presence, então pega token atual sempre.
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        http
          .post("/api/broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((res) => callback(null, res.data))
          .catch((err) => callback(err, null));
      },
    }),
  });

  window.Echo = echoInstance;

  return echoInstance;
}

export function refreshEchoAuthToken() {
  // Com authorizer dinâmico, o token é lido a cada handshake.
  // Esta função existe só pra compatibilidade — não precisa fazer nada.
}

export function disconnectEcho() {
  if (!echoInstance) return;
  echoInstance.disconnect();
  echoInstance = null;
}
